import { Location } from '@angular/common';
import { Component, ElementRef, Injectable, OnDestroy, OnInit, ViewChild, inject } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { MatSidenav } from '@angular/material/sidenav';
import { DomSanitizer } from '@angular/platform-browser';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { MessageUtilities } from '../../../class/message-utilities';
import { T5Message } from '../../../interface/t5-message';
import { UnsubscribeAll } from '../../../class/unsubscribe-all';
import { Utilities } from '../../../class/utilities';
import {
  CAMPAIGN_TYPES,
  CampaignEventSource,
  CampaignEventType,
  EligibleCampaignListItem,
  HighlightedCampaignEligibility
} from '../../../interface/campaign';
import { Message } from '../../../interface/message';
import { SideMenu, SideMenuChild } from '../../../interface/side-menu';
import { MkgUser } from '../../../interface/user';
import { CompanyService } from '../../../service/company.service';
import { UserCompaniesService } from '../../../service/user-companies.service';
import { HighlightedCampaignPopupService } from '../../../service/highlighted-campaign-popup.service';
import { DataCacheService } from '../../../service/data-cache.service';
import { DataService } from '../../../service/data.service';
import { LayoutService } from '../../../service/layout.service';
import { MessageService } from '../../../service/message.service';
import { ReverseRouterService } from '../../../service/reverse-router.service';
import { RoService } from '../../../service/ro.service';
import { SnackbarService } from '../../../service/snackbar.service';
import { authorizationTypes } from '../../../shared/lists/authorization-types';
import { companyStates } from '../../../shared/lists/company-states';
import { messageTypes } from '../../../shared/lists/message-types';
import { RO_STATES } from '../../../shared/lists/ro-states';
import { roles } from '../../../shared/lists/roles';
import { Company, COMPANY_STATE } from '../../../interface/company';
import { filter, first } from 'rxjs';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { fade4, fadeAnimation, fadeSlide, routerTransition, triggerAnimation } from './animations';
import { MatDialog } from '@angular/material/dialog';
import { HighlightedCampaignDialogComponent } from './highlighted-campaign-dialog/highlighted-campaign-dialog.component';
import { T5MsgDialogComponent } from './t5-msg-dialog/t5-msg-dialog.component';
import { UserPreferencesDialogComponent } from './user-preferences-dialog/user-preferences-dialog.component';
import { T5MessagesService } from 'src/app/service/t5-messages.service';
import laborIcon from '../../../../assets/images/icons/labor';
import whatsAppIcon from '../../../../assets/images/icons/whatsapp';
import { FormControl } from '@angular/forms';
import { CachedOsService } from '../../page/company/os/services/cached-os.service';
import { BOOLEAN_TWO } from '@app/shared/common-enums/boolean-two';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  animations: [fade4, fadeAnimation, routerTransition, triggerAnimation, fadeSlide]
})
@Injectable()
export class HeaderComponent extends UnsubscribeAll implements OnInit, OnDestroy {

  @ViewChild('rightDrawer', { static: false }) rightDrawer: MatSidenav;

  Utilities = Utilities;
  COMPANY_STATES = COMPANY_STATE;
  BOOLEAN_TWO = BOOLEAN_TWO
  roles = roles;

  messages: Message[];
  unread = 0;
  newUsers = 0;

  isPO360 = environment.dota;
  APP_NAME = environment.envName;

  T5Msgs: T5Message[] = [];

  T5MsgMenuVisible = false;
  isRobotPopupOpen = false;
  highlightedCampaignEligibility: HighlightedCampaignEligibility | null = null;
  eligibleCampaigns: EligibleCampaignListItem[] = [];

  private userCompanies = inject(UserCompaniesService);

  constructor(
    public companyService: CompanyService,
    public dataService: DataService,
    public layout: LayoutService,
    private reverseRouter: ReverseRouterService,
    private location: Location,
    private messageService: MessageService,
    private roService: RoService,
    private auth: AngularFireAuth,
    private router: Router,
    private snackbar: SnackbarService,
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,
    private _dataCacheService: DataCacheService,
    private dialog: MatDialog,
    private t5Messages: T5MessagesService,
    private _commonOsService: CachedOsService,
    private highlightedCampaignPopupService: HighlightedCampaignPopupService
  ) {
    super();
    this.iconRegistry.addSvgIconLiteral('labor', this.sanitizer.bypassSecurityTrustHtml(laborIcon));
    this.iconRegistry.addSvgIconLiteral('whatsapp', this.sanitizer.bypassSecurityTrustHtml(whatsAppIcon));
  }

  ngOnInit() {
    this.getData();
    this.observeHighlightedCampaign();
  }

  ngOnDestroy() {
    this.unsubscribeAll();
  }

  ativaSnack() {
    this.newMessageSnackbar();
  }

  private getData() {
    this.newUsers = this.layout.menu.newUsers;
    this.messageService.getAll().subscribe(messagesMap => {
      try {
        if (this.messages && this.messages.length < messagesMap.size) {
          this.newMessageSnackbar()
        }
      } catch (error) {
        console.error(error)
      }

      this.messages = [];

      this.dataService.company$.pipe(
        filter(c => !!c),
        first()
      ).subscribe(company => {
        const readMessages = MessageUtilities.getReadMessages(company.id);
        this.unread = 0;
        if (!messagesMap) { return }
        messagesMap.forEach(message => {

          if (message.type >= messageTypes.authorized.id && message.type <= messageTypes.evaluated.id) {
            for (let readMessage of readMessages) {
              if (readMessage == message.id) {
                message.read = true;
                break;
              }
            }
            if (!message.read) {
              this.unread++;
            }
            this.messages.push(message);
          }
        });
        this.messages = this.messages.sort((a, b) => {
          if (a.read !== b.read) {
            return a.read ? 1 : -1;
          }
          return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();

        });
      })
    });

    this.dataService.user$
      .pipe(filter(user => !!user))
      .subscribe(() => {
        this.userCompanies.reload();
      });

    this.t5Messages.getAll().then(messages => {
      this.T5Msgs = this.sortT5Messages(messages);
    });

    if (this.layout.component == '') {
      this.newUsers = 0
      return
    }
    setTimeout(() => {
      if (this.layout.menu.newUsers > this.newUsers) {
        this.newUsers = this.layout.menu.newUsers;
        this.newRequestSnackbar()
      }
    }, 1600);
  }

  get hasRobotMessages(): boolean {
    return this.eligibleCampaigns.length > 0 || this.T5Msgs.length > 0;
  }

  get highlightedCampaignHeadline(): string {
    return this.highlightedCampaignEligibility?.campaign?.headline ?? '';
  }

  get highlightedCampaignSummary(): string {
    return this.highlightedCampaignEligibility?.campaign?.bodyText
      || this.highlightedCampaignEligibility?.campaign?.mediaAsset?.title
      || 'Abrir campanha destacada';
  }

  getCampaignHeadline(item: EligibleCampaignListItem): string {
    return item.campaign?.headline ?? '';
  }

  getCampaignSummary(item: EligibleCampaignListItem): string {
    return item.campaign?.bodyText
      || item.campaign?.mediaAsset?.title
      || 'Abrir campanha destacada';
  }

  getCampaignTypeLabel(item: EligibleCampaignListItem): string {
    const campaignType = item.campaign?.campaignType;

    if (campaignType === CAMPAIGN_TYPES.ALERTA) {
      return 'Alerta';
    }

    if (campaignType === CAMPAIGN_TYPES.NOVIDADES) {
      return 'Novidades';
    }

    return 'Informativo';
  }

  isCampaignViewed(item: EligibleCampaignListItem): boolean {
    return item.userState?.hasSeenPopup === true;
  }

  async toggleMessages() {
    this.rightDrawer.toggle();
    if (this.rightDrawer.opened && this.messages && this.messages.length && !this.messages[0].ro) {
      this.layout.loader = true;
      const actives = await this.roService.getAll(RO_STATES.all);
      const finisheds = await this.roService.getAll(RO_STATES.finished);
      const roList = new Map(Array.from(actives).concat(Array.from(finisheds)));

      this.messages.forEach(message => {
        message.ro = roList.get(message.text);
      });
      let messagesFiltered = [];

      for (const message of this.messages) {
        if (message.ro) {
          messagesFiltered.push(message);
        }
      }
      this.messages = messagesFiltered;
      this.layout.loader = false;
    }
  }

  newMessageSnackbar() {
    try {
      this.snackbar.info('NEW');
    } catch (error) {
      this.layout.loader = false;
    }
  }

  newRequestSnackbar() {
    const user = this.layout.newUserName;
    try {
      this.snackbar.info('NEW_USER', { user: user });
    } catch (error) {
      this.layout.loader = false;
    }
  }

  goBack() {
    if (this.layout.component === 'blocked') {
      this.router.navigate(['/company'])
      return
    }
    if (window.history.length > 1) {
      this.location.back()
    } else {
      this.router.navigate(['/company'])
    }
  }

  async signOut() {
    this.auth.signOut();
  }

  openUserPreferencesDialog(): void {
    this.dialog.open(UserPreferencesDialogComponent);
  }

  public resetCache(component: string) {
    this.reverseRouter.clear();
    this._dataCacheService.reset();

    console.log({component})
    if (!["budgets", "opened", "rejected", "budget", "closed-budget", "ended", "ro", "closed"].includes(component)) {
      this._commonOsService.clearCache();
    }
  }

  public navigateOrExpand(menu: SideMenu | SideMenuChild) {
    if (!menu.href || this.layout.component === menu.component || menu.component === 'budgets') {
      this.layout.toggle(menu.component, menu["isTopLevel"]);
      return
    }
    this.router.navigate(menu.href, {
      queryParams: menu.queryParams
    });
  }

  changeCompany(company: Company){
    let currentUrl = this.router.url.split('/').slice(1);

    this.dataService.company$.pipe(first()).subscribe(currComp => {
      if(company && currComp){
        const idIndex = currentUrl.findIndex(id => id === currComp.id);
        if (idIndex !== -1) {
          currentUrl[idIndex] = company.id;

          if (currentUrl.find(urlPart => urlPart === "detail")) {
            currentUrl = currentUrl.splice(0, currentUrl.length - 2);
            currentUrl.push("budget");
          } else if (company.currentState === COMPANY_STATE.integrated) {
            currentUrl = ["company", company.id, "os","budget"]
          };

          const newUrl = '/' + currentUrl.join('/');
          window.location.href = newUrl;
          return;
        }
      }
      this.router.navigate(['company', company.id]);
    })

  }

  prepareRoute(outlet: RouterOutlet) {
    return outlet && outlet.activatedRouteData && outlet.activatedRouteData['animation'];
  }

  toggleT5MsgDropdown() {
    if (this.isRobotPopupOpen) {
      return;
    }

    this.T5MsgMenuVisible = !this.T5MsgMenuVisible;
  }

  openHighlightedCampaignFromRobot(): void {
    if (!this.highlightedCampaignEligibility?.campaign || this.isRobotPopupOpen) {
      return;
    }

    this.openHighlightedCampaignDialog(this.highlightedCampaignEligibility, CampaignEventSource.WEB_APP);
    this.T5MsgMenuVisible = false;
  }

  openCampaignFromRobot(item: EligibleCampaignListItem): void {
    if (!item?.campaign || this.isRobotPopupOpen) {
      return;
    }

    const eligibility: HighlightedCampaignEligibility = {
      campaign: item.campaign,
      delivery: item.delivery,
      userState: item.userState,
      evaluatedAt: new Date().toISOString()
    };

    this.openHighlightedCampaignDialog(eligibility, CampaignEventSource.WEB_APP);
    this.T5MsgMenuVisible = false;
  }

  openT5MsgDialog(item: T5Message): void {
    if (this.isRobotPopupOpen) {
      return;
    }

    this.T5MsgMenuVisible = false;
    this.isRobotPopupOpen = true;

    const dialogRef = this.dialog.open(T5MsgDialogComponent, {
      data: {
        _id: item._id,
        title: item.title,
        description: item.description,
        createdAt: item.createdAt,
        type: item.type,
        segment: item.segment,
        link: item.link,
        image: item.image
      },
      panelClass: 't5-msg-dialog-container'
    });

    dialogRef.afterClosed().subscribe(() => {
      this.isRobotPopupOpen = false;
    });

    if (item._id) {
      this.t5Messages.markAsRead(item._id)
        .then(() => {
          const index = this.T5Msgs.findIndex(msg => msg._id === item._id);
          if (index !== -1) {
            this.T5Msgs[index].messageStatus = 2;
            this.T5Msgs = this.sortT5Messages([...this.T5Msgs]);
          }
        })
        .catch(error => console.error('Error marking message as read:', error));
    }

  }

  private sortT5Messages(messages: T5Message[]): T5Message[] {
    return [...messages].sort((firstMessage, secondMessage) => {
      if (firstMessage.messageStatus !== secondMessage.messageStatus) {
        return firstMessage.messageStatus - secondMessage.messageStatus;
      }

      const firstCreatedAt = firstMessage.createdAt ? new Date(firstMessage.createdAt).getTime() : 0;
      const secondCreatedAt = secondMessage.createdAt ? new Date(secondMessage.createdAt).getTime() : 0;

      return secondCreatedAt - firstCreatedAt;
    });
  }

  private observeHighlightedCampaign(): void {
    this.subs.push(
      this.dataService.ready$
        .pipe(filter(([user, company]) => Boolean(user?.id) && Boolean(company?.id)))
        .subscribe(([user, company]) => {
          void this.loadHighlightedCampaign(company, user);
        })
    );

    this.subs.push(
      this.router.events
        .pipe(filter(event => event instanceof NavigationEnd))
        .subscribe(() => {
          if (this.dataService.company?.id && this.dataService.user?.id) {
            void this.loadHighlightedCampaign(this.dataService.company, this.dataService.user);
          }
        })
    );
  }

  private async loadHighlightedCampaign(company: Company, user: MkgUser): Promise<void> {
    if (!company?.id || !user?.id || !this.isEligibleRoute(this.router.url)) {
      return;
    }

    try {
      const list = await this.highlightedCampaignPopupService.fetchAllEligibleCampaigns(company, user);
      const campaigns = list?.campaigns ?? [];

      this.eligibleCampaigns = campaigns.length
        ? campaigns
        : (this.highlightedCampaignPopupService.getStoredCampaignList(company.id, user.id)?.campaigns ?? []);

      // find the highest-priority unviewed campaign for the auto-open popup
      const topUnviewed = this.eligibleCampaigns.find(item => !item.userState?.hasSeenPopup);

      if (!topUnviewed) {
        return;
      }

      const eligibility: HighlightedCampaignEligibility = {
        campaign: topUnviewed.campaign,
        delivery: topUnviewed.delivery,
        userState: topUnviewed.userState,
        evaluatedAt: list?.evaluatedAt ?? new Date().toISOString()
      };

      this.highlightedCampaignEligibility = eligibility;

      if (!eligibility.campaign?.displaySettings?.popupEnabled) {
        return;
      }

      if (!this.highlightedCampaignPopupService.shouldAutoOpenCampaign(company.id, user.id, eligibility.campaign)) {
        return;
      }

      this.highlightedCampaignPopupService.markCampaignAsAutoOpened(company.id, user.id, eligibility.campaign);
      this.openHighlightedCampaignDialog(eligibility, CampaignEventSource.AUTOMATIC_POPUP);
    } catch (error) {
      console.error('Erro ao carregar campanhas elegíveis:', error);
      this.eligibleCampaigns = this.highlightedCampaignPopupService.getStoredCampaignList(company.id, user.id)?.campaigns ?? [];
    }
  }

  private openHighlightedCampaignDialog(
    eligibility: HighlightedCampaignEligibility,
    eventSource: CampaignEventSource
  ): void {
    const campaign = eligibility?.campaign;
    if (!campaign || this.isRobotPopupOpen) {
      return;
    }

    this.T5MsgMenuVisible = false;
    this.isRobotPopupOpen = true;

    void this.highlightedCampaignPopupService.registerEvent(
      eligibility,
      CampaignEventType.POPUP_DISPLAYED,
      eventSource
    );

    const dialogRef = this.dialog.open(HighlightedCampaignDialogComponent, {
      data: {
        eligibility,
        eventSource
      },
      panelClass: 'highlighted-campaign-dialog-panel',
      width: '100vw',
      maxWidth: '100vw',
      height: '100vh',
      maxHeight: '100vh',
      autoFocus: false,
      restoreFocus: false,
      disableClose: campaign.displaySettings?.canBeDismissed === false
    });

    dialogRef.afterClosed().subscribe(() => {
      this.isRobotPopupOpen = false;
    });
  }

  private isEligibleRoute(url: string): boolean {
    return /^\/company\/.+/.test(url)
      && !url.includes('/blocked')
      && !url.includes('/blocked-role');
  }

}
